import { render, staticRenderFns } from "./SlEchartsBar.vue?vue&type=template&id=2aa46ecc&scoped=true&"
import script from "./SlEchartsBar.vue?vue&type=script&lang=js&"
export * from "./SlEchartsBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa46ecc",
  null
  
)

export default component.exports